export default __webpack_public_path__ + "static/media/gameOver_apprenticeshipBtn.c432aa99.png";